// src/components/VisitorContactWidget/components/ContactWidgetHeader.jsx

import React from "react";

import {
  FiArrowLeft,
  FiMessageCircle,
  FiX,
} from "react-icons/fi";

export default function ContactWidgetHeader({
  title,
  subtitle,
  showBack = false,
  onBack,
  onClose,
}) {
  return (
    <header className="bg-gradient-to-r from-[#123B57] via-[#1C567F] to-[#2EA7E0] px-5 pb-5 pt-4 text-white">
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          {showBack ? (
            <button
              type="button"
              onClick={onBack}
              className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/10 transition hover:bg-white/20"
              aria-label="Retour"
            >
              <FiArrowLeft />
            </button>
          ) : (
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-white/10 text-xl">
              <FiMessageCircle />
            </div>
          )}

          <div className="min-w-0">
            <h2 className="truncate text-lg font-semibold">
              {title}
            </h2>

            {subtitle && (
              <p className="mt-1 text-xs leading-5 text-white/75">
                {subtitle}
              </p>
            )}
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/10 transition hover:bg-white/20"
          aria-label="Fermer"
        >
          <FiX />
        </button>
      </div>
    </header>
  );
}